import angular from 'angular';

import RwCurrencyComponent from './rw-currency-component';
import RwCurrencyController from './rw-currency-controller';

export default angular
  .module('rw-currency', [])
  .controller('RwCurrencyController', RwCurrencyController)
  .component('rwCurrency', RwCurrencyComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-currency/rw-currency-module.js